import { styled } from '@mui/system';

export const Container = styled('div')({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
});
